export default {
  customerPriceChange: "OFFER_INVALIDATION_REASON_CUSTOMER_PRICE_CHANGE"
};
